import React, { createContext, useState, useContext } from "react";

// Create Context
const LanguageContext = createContext();

// Custom Hook for easy access
export const useLanguage = () => useContext(LanguageContext);

// Language Provider Component
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState("English"); // Ensure default is English

    // Toggle between English and Spanish
    const toggleLanguage = () => {
        setLanguage((prevLanguage) => (prevLanguage === "English" ? "Spanish" : "English"));
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
